import React, { useEffect } from 'react';
import { X, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  caption: string;
}
export function VideoModal({
  isOpen,
  onClose,
  videoId,
  caption
}: VideoModalProps) {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-360">
      <div className="w-full max-w-4xl" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={caption} data-id="element-361">
        {/* Close Button */}
        <div className="flex justify-end mb-3" data-id="element-362">
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors p-1.5 rounded-full hover:bg-white/10" aria-label="Close video" data-id="element-363">
            <X size={24} data-id="element-364" />
          </button>
        </div>

        {/* Video Player */}
        <div className="relative w-full aspect-video bg-black rounded-xl overflow-hidden shadow-2xl" data-id="element-365">
          <iframe src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`} title={caption} className="absolute inset-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-366" />
        </div>

        {/* Caption */}
        <p className="text-white font-medium text-center mt-4 text-lg" data-id="element-367">
          {caption}
        </p>

        {/* Disclaimer */}
        <div className="mt-4 flex items-start gap-2.5 justify-center bg-white/5 border border-white/10 rounded-lg px-5 py-3 max-w-2xl mx-auto" data-id="element-368">
          <ShieldCheck size={16} className="text-caces-accent shrink-0 mt-0.5" data-id="element-369" />
          <p className="text-white/60 text-xs leading-relaxed" data-id="element-370">
            {t.home.videos.disclaimer}
          </p>
        </div>
      </div>
    </div>;
}